const list: string[] = [];

export const css = function(str: string) {
  list.push(str);
};

export const serialize = function(): string {
  return list.reverse().join('\n');
};